// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Lato', 'Lato Fallback'","fontWeight":400},"className":"__className_a2e700","variable":"__variable_a2e700"};